import React, { useCallback, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import { useMount, useUpdateEffect, usePrevious } from 'react-use';
import * as selectors from '@/models/notifies/selectors'
import dayjs from 'dayjs';
import {Button,Table, Breadcrumb, Divider,message } from 'antd';
import { withQuery } from '@/utils';
import * as actions from '@/models/notifies/actions';
import styles from './notifycenter.module.scss';
import { fetchedNotify } from '@/models/notifies/actions'
import * as apis from '@/apis'
function getColumns({ fetch }) {
    const dispatch = useDispatch()
    const showInfoDialog = useCallback(item => event => {
      event.preventDefault()
      //let notify = {title:item.notify.title,content:item.notify.content}
      dispatch(actions.showInfoDialog({
        notify: item.notify,
        title: '消息详情',
        ismodify: "modify",
        disabled: true,
        review: true
      }))
      dispatch(actions.readUserNotify(item._id,readCallBack))
    })
    const deleteNotify = useCallback((item) => event => {
      event.preventDefault()
      dispatch(actions.deleteUserNotify(item._id,fetch))
    })
    const readNotify = useCallback((item) => event => {
      event.preventDefault()
      dispatch(actions.readUserNotify(item._id,readCallBack))
    })
    const readCallBack = useCallback(() => {
      fetch()
      dispatch(fetchedNotify())
    })
    return [
      {
        key: '_id',
        title: '',
        width: 30,
        render: (text, record, idx) => <div style={{whiteSpace: 'nowrap'}}>{idx+1}.</div>
      },
      {
        title: '标题',
        width: 200,
        render: item => (
          <div>{item.notify?.title}</div>
        )
      },
      {
        title: '内容',
        render: item => (
          <div>
            <div>{item.notify?.content}</div>
          </div>
        )
      },
      {
        title: '创建时间',
        width: 180,
        render: item => (
          <div>
            {item.createdAt ? dayjs(item.createdAt).format('YYYY-MM-DD  HH:mm:ss') : '-'}
          </div>
        )
      },
      {
        title: '状态',
        render: item => (
          <div>
            <div>{item.isRead?'已读':'未读'}</div>
          </div>
        )
      },
      {
        title: '阅读时间',
        width: 180,
        render: item => (
          <div>
            {item.readAt ? dayjs(item.readAt).format('YYYY-MM-DD  HH:mm:ss') : '-'}
          </div>
        )
      },
      {
        title: '操作',
        width: 280,
        render: item => {
          return (
            <div>
              <a onClick={showInfoDialog(item)}>详情</a>
              <Divider type="vertical" />
              <a onClick={deleteNotify(item,fetch)}>删除</a>
              { !item.isRead && ( <><Divider type="vertical" /> <a onClick={readNotify(item,fetch)}>标记已读</a></>)}
            </div>
          )
        }
      }
    ]
  }
//消息管理
function NotifiyCenter(props) {
    const dispatch = useDispatch()
    const { query, history, match, location } = props
    const prevQuery = usePrevious(query)
    const limit = query.limit || 10
    const offset = query.offset || 0
    const loading = useSelector(selectors.loadingSelector)
    const total = useSelector(selectors.totalSelector)
    const notifies = useSelector(selectors.entriesSelectors)
    const pagination = {
      showQuickJumper: true,
      total: total,
      pageSize: +limit,
      current: Math.floor(offset / +limit) + 1
    }
    const fetch = useCallback((params = {}) => {
      params.offset = params.offset || offset
      params.limit = params.limit || limit
      dispatch(actions.fetchUserNotifyList(params))
    })
    const readAllNotify = useCallback((title) => () => {
      dispatch(actions.readUserAllNotify(readCallBack))
    })
    const readCallBack = useCallback(() => {
      fetch()
      dispatch(fetchedNotify())
    })
    const handleTableChange = useCallback((pagination, filters, sorter) => {
      const nextQuery = {
        ...query,
        ...filters,
        offset: (pagination.current - 1) * pagination.pageSize
      }
  
      if (sorter && sorter.field) {
        nextQuery.sort = (sorter.order && sorter.order === 'descend' ? '' : '-' ) + sorter.field
      }
      window.scrollTop = 0
      history.push(`/notifyCenter?${qs.stringify(nextQuery)}`)
    })
    
    const columns = getColumns({ fetch })
  
    useMount(() => {
      fetch(query)
    })
  
    useUpdateEffect(() => {
      if (prevQuery.offset !== query.offset) {
        window.scrollTop = 0
        fetch(query)
      }
    })

    return (<div className={styles.container}>
        <div className={styles.header}>
          <Breadcrumb>
            <Breadcrumb.Item>消息中心</Breadcrumb.Item>
            <Breadcrumb.Item>列表</Breadcrumb.Item>
          </Breadcrumb>
          <Button size="small" onClick={readAllNotify()}>标记所有为已读</Button>
        </div>
        <Table
          className={styles.table}
          columns={columns}
          rowKey="_id"
          dataSource={notifies.toJS()}
          pagination={pagination}
          onChange={handleTableChange}
          loading={loading}></Table>
      </div>);
}
export default withQuery(NotifiyCenter);